import React from "react";
import { Grid, Typography } from "@material-ui/core";

import Button from "../../../../../components/elements/Button";
import classes from "../../CampaignsDashboard.module.scss";

type LandingPageViewModeProps = {
  landingPage: string;
  changeMode: () => void;
};

const LandingPageViewMode = ({ landingPage, changeMode }: LandingPageViewModeProps) => {
  return (
    <Grid className={classes.landingPageContainer}>
      <Typography>
        <a href={landingPage} target="blank">
          {landingPage}
        </a>
      </Typography>
      <Button onClick={changeMode}>Edit</Button>
    </Grid>
  );
};

export default LandingPageViewMode;
